import * as React from 'react';
import { Box, Flex, Heading, Text } from 'core/components';
import CloudIcon from 'app/views/hybrid/maps/components/CloudIcon';
import { ENTITY_TYPES } from '@kentik/ui-shared/hybrid/constants';
import CloudDetailLink from 'app/components/links/CloudDetailLink';
import CloudMetadata from 'app/views/hybrid/maps/components/popovers/CloudMetadata';
import SidebarItem from 'app/views/hybrid/maps/components/popovers/SidebarItem';

const { VIRTUAL_CLOUD_NETWORK } = ENTITY_TYPES.get('oci');

const VcnSummary = (config) => {
  const { value, cloudProvider, nodeData } = config;

  const cloudMetadataDetails = {
    node: {
      ...nodeData,
      Name: nodeData.displayName,
      'Created At': new Date(nodeData.timeCreated).toLocaleString()
    },
    keys: ['id', 'Name', 'description', 'cidrBlock', 'region', 'Created At', 'compartmentId', 'tenancyId']
  };

  return (
    <Box>
      <Flex borderBottom="thin" p={2} alignItems="center">
        <CloudIcon cloudProvider={cloudProvider} entity={VIRTUAL_CLOUD_NETWORK} width={32} height={32} />
        <Box flex={1} ml={1}>
          <Text as="div" muted>
            Cloud VCN Details
          </Text>
          <Heading mb={0} level={4}>
            <CloudDetailLink cloud={cloudProvider} detail="vcn" value={value}>
              {nodeData.displayName}
            </CloudDetailLink>
          </Heading>
        </Box>
      </Flex>
      {nodeData && (
        <SidebarItem title="Details" icon="more" popoutTitle={VcnSummary.PopoutTitle(config)}>
          <CloudMetadata {...cloudMetadataDetails} />
        </SidebarItem>
      )}
    </Box>
  );
};

VcnSummary.PopoutTitle = (config) => {
  const { cloudProvider, nodeData } = config;

  return (
    <Flex alignItems="center">
      <CloudIcon cloudProvider={cloudProvider} entity={VIRTUAL_CLOUD_NETWORK} />
      <Box ml={1}>{`${nodeData.displayName} VCN`}</Box>
    </Flex>
  );
};

export default VcnSummary;
